// import fetchWrapper from '../components/utility/fetchWrapper.js';
import { API_BASE_URL } from './config.js';
import fetchWrapper from '../components/utility/fetchWrapper.js';

export const costApi = {
  getPlatformCosts: async (startDate, endDate, granularity = 'DAILY') => {
    const response = await fetchWrapper(
      `${API_BASE_URL}/api/v1/platform-costing/aws/platform-costs?` +
      `start_date=${startDate}&end_date=${endDate}&granularity=${granularity}`
    );
    
    if (!response.ok) {
      const errorText = await response.text();
      throw new Error(`Failed to fetch cost data: ${errorText}`);
    }
    
    const data = await response.json();
    return Array.isArray(data)
      ? data.map((period) => ({
          ...period,
          Costs: Array.isArray(period?.Costs) ? period.Costs : []
        }))
      : [];
  },

  getLast30DaysCosts: async () => {
    const endDate = new Date().toISOString().split('T')[0];
    const startDate = new Date(Date.now() - 30 * 24 * 60 * 60 * 1000).toISOString().split('T')[0];
    return await costApi.getPlatformCosts(startDate, endDate, 'DAILY');
  },

  getThisMonthCosts: async () => {
    const now = new Date();
    const endDate = now.toISOString().split('T')[0];
    const startDate = new Date(now.getFullYear(), now.getMonth(), 1).toISOString().split('T')[0];
    return await costApi.getPlatformCosts(startDate, endDate, 'DAILY');
  },

  getLastMonthCosts: async () => {
    const now = new Date();
    const startDate = new Date(now.getFullYear(), now.getMonth() - 1, 1).toISOString().split('T')[0];
    const endDate = new Date(now.getFullYear(), now.getMonth(), 0).toISOString().split('T')[0];
    return await costApi.getPlatformCosts(startDate, endDate, 'DAILY');
  }
}; 
